// eslint-disable-next-line no-unused-vars
import { motion, AnimatePresence } from "framer-motion"
import { UndoIcon } from "pk-icons"
import FilterIcon from "../../../../../components/icons/filter-icon"
import { langStore } from "@/stores/lang-store"
import { orgSelectBundle } from "@/routes/select/org/org-select-const"

const extra = {
  placeholder: { ko: "수용가 번호로 검색", en: "Search by Customer", es: "Buscar por cliente" },
  filter: { ko: "필터", en: "Filters", es: "Filtros" },
  search: {
    result: { ko: "검색 결과", en: "Results", es: "Resultados de búsqueda" },
    unit: { ko: "개", en: "items", es: "artículos" }
  }
}
const FilterPanel = ({ open, onClose, search, reset, children, width = 360 }) => {
  const { lang } = langStore()

  return (
    <AnimatePresence>
      {open && (
        <>
          {/* Overlay */}
          <motion.div
            className="fixed inset-0 bg-black/20 z-100"
            onClick={onClose}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          />

          {/* Panel */}
          <motion.div
            className="fixed top-0 right-0 h-screen bg-white shadow-xl z-110 flex flex-col"
            style={{ width }}
            initial={{ x: width }}
            animate={{ x: 0 }}
            exit={{ x: width }}
            transition={{ type: "tween", duration: 0.25 }}
          >
            {/* Header */}
            <div className="flex items-center justify-between px-4 h-15 border-b border-b-gray-300">
              <div className="text-lg font-semibold flex items-center gap-3">
                <h2 className="flex items-center gap-0.5">
                  <FilterIcon />
                  {extra.filter[lang]}
                </h2>
                <button
                  className="p-1 hover:bg-gray-100 rounded-sm border border-gray-400 cursor-pointer"
                  onClick={reset}
                >
                  <UndoIcon size={14} />
                </button>
              </div>

              <button className="p-2 rounded-lg cursor-pointer" onClick={onClose}>
                ✕
              </button>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-y-auto px-4 py-4 select-none">{children}</div>

            <button
              className="w-full py-2 bg-[#4b5985] text-white"
              onClick={() => {
                search()
                onClose()
              }}
            >
              {orgSelectBundle.filter.searchButton[lang]}
            </button>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  )
}

export default FilterPanel
